import React, { Component } from 'react'
import StatItem from '../StatItem'
import { StatListContainer } from './styledComponents'

class StatList extends Component {
  render() {
    const { statsList } = this.props
    return (
      <StatListContainer>
        {statsList.map(statData => <StatItem statData={statData} />)}
      </StatListContainer>
    )
  }
}

export default StatList



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/StatsSection/StatList/index.js